var errorCodeObj = {
  // 身份证报错
  idCard: {
    '-1': '离线/链接超时',
    '-2': '未放身份证',
    '-7': '必选项消息不存在',
    '-8': 'Token 无效',
    '-100': '100 Token 过期失效',
    '-10': 'JSON 格式错误',
    '-11': '获取详细信息超时',
    '-12': '处理失败',
    '200': '处理成功',
  },

  // 门卡报错
  doorCard: {
    '-1': '离线/链接超时',
    '-2': '无卡（移动总台设备检测无卡）',
    '-3': '空卡',
    '-4': '无法操作管理卡',
    '-5': '未初始化',
    '-6': '非本酒店卡',
    '-7': '必选项消息不存在',
    '-8': 'Token 无效',
    '-9': '非空卡',
    '-100': 'Token 过期失效',
    '-10': 'JSON 格式错误',
    '-11': '获取详细信息超时',
    '-12': '处理失败',
    '-13': '制卡事件无效',
    '-15': 'S50 卡不能制卡',
    '-16': '制卡信息已存在(移动 PMS)',
    '200': '处理成功',
  },

  // 验证信息的报错
  auth: {
    '-7': '必选项消息不存在',
    '-10': 'JSON 格式错误',
    '-11': '获取详细信息超时',
    '-14': '未知来源账号',
    '-99': '用户名或密码错误',
    '0': '获取 Token 成功',
  }
}

export default errorCodeObj



// WEBPACK FOOTER //
// ./src/conf/jingjiangErrorCode.js